import { render } from "./BillingCycle.vue?vue&type=template&id=bdd624a4"
import script from "./BillingCycle.vue?vue&type=script&lang=js"
export * from "./BillingCycle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__